import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { useVoicemailDropContext } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/context/voicemailDropContext'
import { getVoicemailDropTableActions } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/VoicemailDropListTable/getVoicemailDropTableActions'
import styles from './styles.module.scss'
import { columns } from './columns'

export const VoicemailDropTable = observer(() => {
  const store = useVoicemailDropContext()
  const { initialLoading, tableStore, drops } = store

  const getColumns = useMemo(() => columns(), [drops])

  const rows = useMemo(() => {
    return drops.map((item) => {
      item.setActionsProps({
        actions: getVoicemailDropTableActions(item, store),
      })

      item.setAriaLabel('DropsRow')

      return item
    })
  }, [drops])

  return (
    <section className={styles.table}>
      <Table
        ariaLabel={'VoicemailDropTable'}
        store={tableStore}
        columns={getColumns}
        rows={rows}
        loading={initialLoading}
        hidePagination={true}
      />
    </section>
  )
})
